import {useEffect, useMemo, useState} from "react";
import {showErrorNotification} from "../helpers/mainHelpers";
import {OperationRoomItem} from "../types/operation";
import {operationRoomsService} from "../services/operationRooms-service";

export const useOperationRoomsController = () => {
  const [isLoading, setIsLoading] = useState(false)
  const [operationRoomsList, setOperationRoomsList] = useState<OperationRoomItem[]>([])

  useEffect(() => {
    fetchOperationRoomsList([])
  }, [])

  const fetchOperationRoomsList = async (queries: string[]) => {
    setIsLoading(true)
    try {
      const list = await operationRoomsService.list(queries)
      setOperationRoomsList(list)
    } catch (error) {
      console.error(error)
      showErrorNotification({message: "Помилка завантаження операційних!"});
    } finally {
      setIsLoading(false)
    }
  }

  const operationRoomSelectOptions = useMemo(() => {
    return operationRoomsList?.map((room) => {
      return {
        label: room.name,
        value: room.$id
      }
    }) || []
  }, [operationRoomsList])

  return {isLoading, operationRoomsList, operationRoomSelectOptions}
}
export default useOperationRoomsController